// @ts-nocheck
import CheckOutlined from '@ant-design/icons/CheckOutlined'
import CloseOutlined from '@ant-design/icons/CloseOutlined'
import DownloadOutlined from '@ant-design/icons/DownloadOutlined'
import EditOutlined from '@ant-design/icons/EditOutlined'
import FileTextOutlined from '@ant-design/icons/FileTextOutlined'
import InfoCircleTwoTone from '@ant-design/icons/InfoCircleTwoTone'
import LeftOutlined from '@ant-design/icons/LeftOutlined'
import RightOutlined from '@ant-design/icons/RightOutlined'
import SnippetsOutlined from '@ant-design/icons/SnippetsOutlined'
import {
  Button,
  Card,
  Checkbox,
  Empty,
  Modal,
  Space,
  Spin,
  Tabs,
  Tag,
  Tooltip,
  Upload,
  message,
} from 'antd'
import { inject, observer } from 'mobx-react'
import React, { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { Layer, Stage } from 'react-konva'
import { Document, Page } from 'react-pdf'
import { blue } from '../../color'
import { apiUrl } from '../../config'
import {
  DIGITAL_SIGN_STATUS,
  DIGITAL_TYPE_SIGN_SYSTEM,
  DIGITAL_TYPE_SIGN_USER,
  SIGN_PROVIDER,
  SIGN_VISIBLE,
} from '../../constants'
import utils from '../../utils'
import { trimOverLengthString } from '../Common/CellText'
import ContentBlockWrapper from '../ContentBlockWrapper'
import EmptyContent from '../EmptyContent'
import SpinnerInlineComponent from '../SpinnerInlineComponent/SpinnerInlineComponent'
import {
  DocumentController,
  DocumentWrapper,
  HeaderPopupSign,
  NameDocument,
  PopupSignWrapper,
  SignatureBox,
  SignatureList,
  ThumbnailsWrapper,
} from './PopupSignStyled'
import RectangleBox from './RectangleBox'

const { TabPane } = Tabs
const CheckboxGroup = Checkbox.Group
const { Meta } = Card
const { confirm } = Modal

const PopupSign = props => {
  const {
    signedDocumentStore,
    loadingAnimationStore,
    fileStore,
    authenticationStore,
    isVisiblePopupSign,
    handleClosePopupSign,
    hiddenSelectDocument,
    handleAfterSign,
  } = props

  let { fileId } = props

  const { currentUser } = authenticationStore
  const { fileBlob, originFileObj, responseSign } = signedDocumentStore

  // States
  const [selectedSignature, setSelectedSignature] = useState(null)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [displaySignChecked, setDisplaySignChecked] = useState(false)
  const [otherCheckboxValues, setOtherCheckboxValues] = useState([])
  const [rectangles, setRectangles] = useState([])
  const [styleCanvas, setStyleCanvas] = useState({ width: 595, height: 842 })
  const [pdfPageSize, setPdfPageSize] = useState({ width: 595, height: 842 })
  const [idImg, setIdImg] = useState()
  const [numPages, setNumPages] = useState()
  const [pageNumber, setPageNumber] = useState(1)
  const [thumbnails, setThumbnails] = useState([])
  const [loadedPdf, setLoadedPdf] = useState()
  const [signatureList, setSignatureList] = useState([])
  const [visibleSignature, setVisibleSignature] = useState(SIGN_VISIBLE.VISIBLE)

  // Memoized values
  const scaleFactor = useMemo(() => styleCanvas.width / pdfPageSize.width, [
    styleCanvas.width,
    pdfPageSize.width,
  ])

  const options = useMemo(
    () => [
      {
        key: 1,
        label: 'Ẩn chữ ký',
        value: SIGN_VISIBLE.HIDE,
      },
    ],
    []
  )

  const filteredSignatureList = useMemo(
    () =>
      signatureList?.filter(signature => signature.status !== 'DELETE') || [],
    [signatureList]
  )

  const documentControllerProps = useMemo(
    () => ({
      maxWidth: styleCanvas.width,
    }),
    [styleCanvas.width]
  )

  const nameDocumentProps = useMemo(
    () => ({
      maxWidth: styleCanvas.width,
      signed: !!responseSign,
    }),
    [styleCanvas.width, responseSign]
  )

  const stageProps = useMemo(
    () => ({
      width: styleCanvas.width,
      height: styleCanvas.height,
      style: {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        border: styleCanvas.border,
        top: 92,
        zIndex: 9,
      },
      draggable: true,
    }),
    [styleCanvas]
  )

  const documentSpinProps = useMemo(
    () => ({
      style: { display: 'flex', justifyContent: 'center' },
      loading: (
        <div className={'spin-box'}>
          <Spin tip="Đang tải tài liệu" />
        </div>
      ),
    }),
    []
  )

  const emptyDocumentProps = useMemo(
    () => ({
      image: Empty.PRESENTED_IMAGE_SIMPLE,
      description: 'Vui lòng chọn tài liệu ký số!',
    }),
    []
  )

  const thumbnailsDocumentProps = useMemo(
    () => ({
      noData: (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={'Hãy chọn tài liệu!'}
        />
      ),
      loading: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 170,
          }}>
          <Spin />
        </div>
      ),
    }),
    []
  )

  const pageNavigationInfo = useMemo(
    () => ({
      current: pageNumber,
      total: numPages,
      canGoBack: pageNumber > 1,
      canGoForward: pageNumber < numPages,
    }),
    [pageNumber, numPages]
  )

  const downloadFileInfo = useMemo(() => {
    if (!responseSign?.data?.listSignFile?.length) return null
    return {
      fileSignId: responseSign.data.listSignFile[0].fileSignId,
      fileSignName: responseSign.data.listSignFile[0].fileSignName,
    }
  }, [responseSign])

  const rectangleComponents = useMemo(() => {
    if (!rectangles || !idImg) return null

    return rectangles.map((rect, i) => (
      <RectangleBox
        style={{
          width: 300,
          height: 36,
          border: '1px solid red',
          backgroundColor: 'red',
          display: 'block',
        }}
        urlImg={`${apiUrl}/api/v1/images/${idImg}`}
        key={i}
        shapeProps={rect}
        isSelected={true}
        onChange={newAttrs => {
          const updatedRects = [...rectangles]
          updatedRects[i] = newAttrs
          setRectangles(updatedRects)
        }}
      />
    ))
  }, [rectangles, idImg])

  const signatureCards = useMemo(() => {
    if (!filteredSignatureList.length) {
      return (
        <EmptyContent description={'Bạn chưa có chữ ký nào, hãy tạo chữ ký!'} />
      )
    }

    return filteredSignatureList.map(signature => (
      <SignatureBox
        key={signature.signId}
        onClick={() => onSignatureCheckChanged(signature)}>
        <Card
          hoverable
          className={'card'}
          cover={
            <div className={'img-box'}>
              <img
                alt="signature"
                src={`${apiUrl}/api/v1/images/${signature.signId}`}
                id={signature.signId}
              />
            </div>
          }>
          <Meta
            title={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}>
                <span>{signature.signName}</span>
                <Checkbox checked={selectedSignature === signature} />
              </div>
            }
          />
        </Card>
      </SignatureBox>
    ))
  }, [filteredSignatureList, selectedSignature])

  const thumbnailPages = useMemo(
    () =>
      thumbnails.map(thumbnailNumber => (
        <div
          className={
            thumbnailNumber === pageNumber
              ? 'thumbnail-box thumbnail-box-active'
              : 'thumbnail-box'
          }
          onClick={() => setPageNumber(thumbnailNumber)}
          key={thumbnailNumber}>
          <Page pageNumber={thumbnailNumber} loading={null} width={125} />
          <div style={{ fontWeight: 'bold' }}>{thumbnailNumber}</div>
        </div>
      )),
    [thumbnails, pageNumber]
  )

  const handleFinishSign = useCallback(() => {
    setSelectedSignature(null)
    setRectangles(null)
    setIdImg(null)
    setPageNumber(1)
    setDisplaySignChecked(false)
    setOtherCheckboxValues([])
    handleClosePopupSign()
    signedDocumentStore.clearDataPopupSign()
    setStyleCanvas(prev => ({ ...prev, border: null }))
  }, [handleClosePopupSign, signedDocumentStore])

  const handleSelectSignature = useCallback(signature => {
    if (!signature?.signId) return
    setIdImg(signature?.signId)

    const img = document.getElementById(signature?.signId)
    const imgWidth = img.naturalWidth
    const imgHeight = img.naturalHeight

    const aspectRatio = imgWidth / imgHeight
    const isLandscape = aspectRatio > 1
    const isPortrait = aspectRatio < 1

    let calculatedWidth, calculatedHeight
    if (signature.typeSignature === 'MAIN_SIGN') {
      calculatedWidth = imgWidth * 0.2
      calculatedHeight = imgHeight * 0.2
    } else if (isLandscape) {
      calculatedWidth = imgWidth * 0.7
      calculatedHeight = calculatedWidth / aspectRatio
    } else if (isPortrait) {
      calculatedHeight = imgHeight * 0.7
      calculatedWidth = calculatedHeight * aspectRatio
    } else {
      calculatedWidth = imgWidth * 0.7
      calculatedHeight = imgHeight * 0.7
    }

    setRectangles([
      {
        x: 10,
        y: 10,
        width: calculatedWidth,
        height: calculatedHeight,
        id: 'rect1',
      },
    ])
  }, [])

  const handleSign = useCallback(async () => {
    if (utils.isNullish(selectedSignature))
      return message.error('Bạn phải chọn chữ ký trước khi ký!')

    loadingAnimationStore.showSpinner(true)
    const formData = new FormData()
    formData.append('file', originFileObj)

    const signId = selectedSignature.signId
    const img = document.getElementById(signId)
    const imgWidth = img.naturalWidth
    const imgHeight = img.naturalHeight
    const ratioImg = imgWidth / imgHeight

    const scale = ratioImg
    const newWidth = imgWidth * scale
    const newHeight = imgHeight * scale

    const fnLlx = rectangles[0].x * scaleFactor
    const fnLly =
      styleCanvas.height -
      (rectangles[0].y + rectangles[0].height * scaleFactor)
    const fnUrx = fnLlx + rectangles[0].width
    const fnUry = fnLly + rectangles[0].height

    try {
      if (!fileId) {
        const { data } = await fileStore.uploadFile(formData)
        fileId = data.file_id
      }

      let dataSubmit = {
        reason: 'Signed',
        location: 'VietNam',
        contactInfo: '',
        provider: SIGN_PROVIDER.FPT,
        isVisible: visibleSignature,
        listSignFile: [{ fileId: fileId }],
      }

      if (idImg) {
        dataSubmit = {
          ...dataSubmit,
          type:
            selectedSignature.type === DIGITAL_TYPE_SIGN_SYSTEM
              ? DIGITAL_TYPE_SIGN_SYSTEM
              : DIGITAL_TYPE_SIGN_USER,
          image: idImg,
          page: pageNumber,
          llx: fnLlx,
          lly: fnLly,
          urx: fnUrx,
          ury: fnUry,
        }
      } else {
        dataSubmit = {
          ...dataSubmit,
          type: DIGITAL_TYPE_SIGN_SYSTEM,
          image: '',
          page: 1,
          llx: 300,
          lly: 794,
          urx: 590,
          ury: 830,
        }
      }

      const res = await signedDocumentStore.signDocumentSavis(dataSubmit)
      signedDocumentStore.setResponseSign(res)

      if (handleAfterSign) {
        signedDocumentStore.setResponseSign(undefined)
        await handleAfterSign(res.data.listSignFile[0].fileSignId)
      }

      setIsModalVisible(false)
      setSelectedSignature(null)
      message.success('Ký số thành công!')
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Ký số thất bại!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }, [
    fileId,
    fileStore,
    handleAfterSign,
    idImg,
    loadingAnimationStore,
    originFileObj,
    pageNumber,
    rectangles,
    scaleFactor,
    selectedSignature,
    signedDocumentStore,
    visibleSignature,
    styleCanvas.height,
  ])

  const showSignConfirm = useCallback(() => {
    if (
      (selectedSignature &&
        selectedSignature.status === DIGITAL_SIGN_STATUS.APPROVAL) ||
      selectedSignature == null
    ) {
      confirm({
        title: 'Bạn có chắc chắn muốn ký tài liệu này?',
        icon: <InfoCircleTwoTone />,
        content: '',
        okText: 'Đồng ý',
        okType: 'primary',
        cancelText: 'Hủy bỏ',
        onOk() {
          handleSign()
        },
        onCancel() {
          setStyleCanvas(prev => ({ ...prev, border: null }))
          console.log('Hủy ký')
        },
      })
    } else {
      message.info('Chữ ký này chưa được duyệt')
    }
  }, [selectedSignature, handleSign])

  const renderPage = useCallback(async (pdf, pageNumber) => {
    const page = await pdf.getPage(pageNumber)
    const viewport = page.getViewport({ scale: 1 })
    setStyleCanvas({
      width: viewport.width,
      height: viewport.height,
      border: '1px solid #000',
    })
    setPdfPageSize({ width: viewport.width, height: viewport.height })
  }, [])

  const onDocumentLoadSuccess = useCallback(
    pdf => {
      const { numPages } = pdf
      setNumPages(numPages)
      const thumbnails = []
      for (let i = 0; i < numPages; i++) {
        thumbnails.push(i + 1)
      }
      setThumbnails(thumbnails)
      setLoadedPdf(pdf)
      renderPage(pdf, pageNumber)
    },
    [renderPage, pageNumber]
  )

  const onSelectDocument = useCallback(
    file => {
      const newFile = new Blob([file.file], { type: 'application/pdf' })
      signedDocumentStore.setFileBlob(newFile)
      signedDocumentStore.setOriginFileObj(file.file)
    },
    [signedDocumentStore]
  )

  const onSignatureCheckChanged = useCallback(
    signature => {
      if (signature === selectedSignature) {
        handleSelectSignature(null, null)
        setSelectedSignature(null)
        setIdImg(null)
        setRectangles(null)
        return
      }
      const signId = signature.signId
      const img = document.getElementById(signId)
      handleSelectSignature(signature, img.naturalWidth / img.naturalHeight)
      setSelectedSignature(signature)
    },
    [selectedSignature, handleSelectSignature]
  )

  const onSignVisibleChange = useCallback(values => {
    setVisibleSignature(
      values.length > 0 ? SIGN_VISIBLE.HIDE : SIGN_VISIBLE.VISIBLE
    )
  }, [])

  const handlePageNavigation = useCallback(
    direction => {
      if (direction === 'prev' && pageNavigationInfo.canGoBack) {
        const newPage = pageNumber - 1
        setPageNumber(newPage)
        renderPage(loadedPdf, newPage)
      } else if (direction === 'next' && pageNavigationInfo.canGoForward) {
        const newPage = pageNumber + 1
        setPageNumber(newPage)
        renderPage(loadedPdf, newPage)
      }
    },
    [pageNumber, loadedPdf, renderPage, pageNavigationInfo]
  )

  const handleDownloadFile = useCallback(() => {
    if (downloadFileInfo) {
      fileStore.handleDownloadFile(
        downloadFileInfo.fileSignId,
        downloadFileInfo.fileSignName
      )
    }
  }, [fileStore, downloadFileInfo])

  useEffect(() => {
    if (!currentUser) return
    loadingAnimationStore.setShowSpinInline(true)
    signedDocumentStore
      .getUserSignatureList()
      .then(res => {
        setSignatureList(res.data)
      })
      .finally(() => {
        loadingAnimationStore.setShowSpinInline(false)
      })
  }, [currentUser, loadingAnimationStore, signedDocumentStore])

  return (
    <PopupSignWrapper
      visible={isVisiblePopupSign}
      footer={null}
      width={1300}
      style={{ top: 20 }}
      title={
        <HeaderPopupSign>
          <span>Ký số tài liệu</span>
          <Space>
            {!hiddenSelectDocument && (
              <Upload
                accept={'.pdf'}
                beforeUpload={() => false}
                showUploadList={false}
                onChange={onSelectDocument}>
                <Button type="primary" icon={<SnippetsOutlined />}>
                  Chọn tài liệu ký số
                </Button>
              </Upload>
            )}
            {responseSign ? (
              <Button
                type={'primary'}
                icon={<CheckOutlined />}
                onClick={handleFinishSign}
                style={{ backgroundColor: '#389e0d' }}>
                Hoàn thành
              </Button>
            ) : (
              <Button
                danger
                type={'text'}
                icon={<CloseOutlined />}
                onClick={handleFinishSign}
              />
            )}
          </Space>
        </HeaderPopupSign>
      }>
      <ContentBlockWrapper>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 20,
          }}>
          <div style={{ flexGrow: 1 }}>
            <DocumentWrapper fileBlob={fileBlob}>
              {fileBlob && loadedPdf && (
                <DocumentController {...documentControllerProps}>
                  <Space>
                    <Button
                      type="primary"
                      danger
                      icon={<CloseOutlined />}
                      onClick={handleFinishSign}>
                      Hủy
                    </Button>
                  </Space>
                  {fileBlob && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}>
                      <Button
                        style={{ width: 42 }}
                        onClick={() => handlePageNavigation('prev')}
                        icon={<LeftOutlined />}
                      />
                      <p style={{ margin: '0 10px' }}>
                        {pageNavigationInfo.current}/ {pageNavigationInfo.total}
                      </p>
                      <Button
                        style={{ width: 42 }}
                        onClick={() => handlePageNavigation('next')}
                        icon={<RightOutlined />}
                      />
                    </div>
                  )}
                  <Button
                    type="primary"
                    icon={<EditOutlined />}
                    onClick={showSignConfirm}>
                    Ký tài liệu
                  </Button>
                </DocumentController>
              )}

              {originFileObj && loadedPdf && !responseSign && (
                <NameDocument {...nameDocumentProps}>
                  <Tooltip>
                    <FileTextOutlined
                      style={{ color: blue, fontSize: 16, marginRight: 10 }}
                    />
                    <span style={{ lineHeight: '20px' }}>
                      {trimOverLengthString(originFileObj.name, 70)}
                    </span>
                  </Tooltip>
                </NameDocument>
              )}

              {responseSign &&
                loadedPdf &&
                responseSign.data?.listSignFile?.length > 0 && (
                  <NameDocument {...nameDocumentProps}>
                    <Tooltip title={'Tải xuống'}>
                      <div onClick={handleDownloadFile}>
                        <DownloadOutlined
                          style={{
                            color: '#27ae60',
                            fontSize: 16,
                            marginRight: 10,
                          }}
                        />
                        <span style={{ lineHeight: '20px' }}>
                          {trimOverLengthString(
                            downloadFileInfo?.fileSignName,
                            70
                          )}
                        </span>
                        <Tag color={'green'} style={{ marginLeft: 8 }}>
                          Đã ký
                        </Tag>
                      </div>
                    </Tooltip>
                  </NameDocument>
                )}

              {fileBlob ? (
                <div className={'document-wrapper'}>
                  <Document
                    {...documentSpinProps}
                    file={fileBlob}
                    onLoadSuccess={onDocumentLoadSuccess}>
                    <Page pageNumber={pageNumber} loading={null} />
                  </Document>
                </div>
              ) : (
                <Empty {...emptyDocumentProps} />
              )}

              <Stage {...stageProps}>
                <Layer
                  style={{
                    width: 300,
                    height: 36,
                    border: '1px solid red',
                    backgroundColor: 'red',
                    display: 'block',
                  }}>
                  {rectangleComponents}
                </Layer>
              </Stage>
            </DocumentWrapper>
          </div>

          <div style={{ width: 300, minHeight: 'calc(100vh - 140px)' }}>
            <Tabs defaultActiveKey="1">
              <TabPane tab="Tùy chọn ký" key="1">
                <div style={{ marginBottom: '1rem' }}>
                  <label style={{ fontWeight: 600, marginRight: 10 }}>
                    Loại ký:{' '}
                  </label>
                  <CheckboxGroup
                    options={options}
                    onChange={onSignVisibleChange}
                  />
                </div>
                <div style={{ position: 'relative' }}>
                  <SpinnerInlineComponent sizeSpin={'small'} />
                  <p style={{ fontWeight: 600 }}>Chữ ký:</p>
                  <SignatureList>{signatureCards}</SignatureList>
                </div>
              </TabPane>
              <TabPane tab="Phụ lục tài liệu" key="2">
                <ThumbnailsWrapper>
                  <Document {...thumbnailsDocumentProps} file={fileBlob}>
                    {thumbnailPages}
                  </Document>
                </ThumbnailsWrapper>
              </TabPane>
            </Tabs>
          </div>
        </div>
      </ContentBlockWrapper>
    </PopupSignWrapper>
  )
}

PopupSign.propTypes = {}

export default memo(
  inject(
    'signedDocumentStore',
    'loadingAnimationStore',
    'authenticationStore',
    'fileStore'
  )(observer(PopupSign))
)
